import { Alert, Box, Button, FormLabel, Grid, Snackbar } from '@mui/material'
import {
  CompanyStatusType,
  SupplierRegionType,
} from 'api/models/Common/JyrneyEnums'
import { Supplier } from 'api/supplier/suppliers.types'
import AccountManagerSelect from 'components/AccountManagerSelect/AccountManagerSelect'
import notifyPopup from 'components/Common/Notification/notifyPopup'
import Checkbox from 'components/RouteWizard/Checkbox'
import Form from 'components/RouteWizard/Form'
import Input from 'components/RouteWizard/Input'
import { Select } from 'components/RouteWizard/Select'
import useSupplier from 'hooks/useSupplier'
import { FC, useState } from 'react'
import { useSelector } from 'react-redux'
import defaultValues from './defaultValues'
import schema from './schema'

export const Company: FC = () => {
  const [formDisabled, setFormDisabled] = useState(true)
  const { updateSupplier, error, isLoading } = useSupplier()
  const supplier: Supplier = useSelector(
    (state: any) => state.suppliers.supplier,
  )

  if (supplier === null) {
    return null
  }

  const onSubmit = (data: any) => {
    console.log('data', data)
    console.log(
      'services',
      Object.entries(data?.services)
        .map((key) => {
          if (typeof key[1] === 'boolean') {
            return key[0]
          }
        })
        .filter((s) => !!s),
    )
    const formData = {
      companyName: data?.companyName,
      registrationNumber: data?.registrationNumber,
      alias: data?.alias,
      status: data?.status,
      regionName: data?.regionName,
      address: data?.address,
      accountManager: data?.accountManager,
      termsAndConditions: data?.termsAndConditions,
      services: Object.entries(data?.services)
        .map((key) => {
          if (typeof key[1] === 'boolean') {
            return key[0]
          }
        })
        .filter((s) => !!s),
    }

    setFormDisabled(true)
    updateSupplier(formData, supplier?.id).then(() => {
      notifyPopup({
        type: error ? 'danger' : 'success',
        message: error
          ? 'Update failed to save'
          : 'Details updated successfully',
      })
    })
  }
  return (
    <Grid container justifyContent="flex-start" sx={{ width: '70%' }}>
      <Form
        schema={schema}
        onSubmit={onSubmit}
        defaultValues={{
          ...defaultValues,
          ...supplier,
          services: supplier?.services.reduce(
            (initVal, service) => ({
              ...initVal,
              [service]: true,
            }),
            {},
          ),
        }}
        showControls={false}
      >
        <FormLabel>Company</FormLabel>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            width: '50%',
          }}
        >
          <Box sx={{ display: 'flex', gap: '20px' }}>
            <Input
              name="companyName"
              sx={{ flexGrow: 0.5 }}
              label="Name"
              disabled={formDisabled}
            />
            <Input
              name="registrationNumber"
              sx={{ flexGrow: 0.5 }}
              label="Company Number"
              disabled={formDisabled}
            />
          </Box>
          <Input
            name="alias"
            sx={{ flexGrow: 0.4 }}
            label="Trading As"
            disabled={formDisabled}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            width: '50%',
          }}
        >
          <AccountManagerSelect disabled={formDisabled} />
        </Box>
        <FormLabel>Service</FormLabel>

        <Box sx={{ display: 'flex', gap: '20px', width: '50%' }}>
          <Select
            options={CompanyStatusType}
            name="status"
            label="Supplier Status"
            sx={{ flexGrow: 0.5 }}
            disabled={formDisabled}
          />

          <Select
            name="regionName"
            label="Service Region"
            options={SupplierRegionType}
            sx={{ flexGrow: 0.5 }}
            disabled={formDisabled}
          />
        </Box>
        <FormLabel>Company Address</FormLabel>
        <Box sx={{ display: 'flex', gap: '20px', width: '50%' }}>
          <Input
            name="address.addressLine1"
            label="Street Address"
            disabled={formDisabled}
            sx={{ flexGrow: 0.4 }}
            InputLabelProps={{
              shrink:
                formDisabled ||
                !(
                  // @ts-ignore
                  (typeof value !== 'undefined' && value === '')
                ),
            }}
          />
          <Input
            name="address.addressLine2"
            label="Street Address Line 2"
            disabled={formDisabled}
            InputLabelProps={{
              shrink:
                formDisabled ||
                !(
                  // @ts-ignore
                  (typeof value !== 'undefined' && value === '')
                ),
            }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
          }}
        >
          <Box sx={{ display: 'flex', gap: '20px', width: '50%' }}>
            <Input
              name="address.town"
              label="Town"
              disabled={formDisabled}
              InputLabelProps={{
                shrink:
                  formDisabled ||
                  !(
                    // @ts-ignore
                    (typeof value !== 'undefined' && value !== '')
                  ),
              }}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '50%',
              gap: '15px',
            }}
          >
            <Input
              name="address.county"
              label="County"
              disabled={formDisabled}
              InputLabelProps={{
                shrink:
                  formDisabled ||
                  !(
                    // @ts-ignore
                    (typeof value !== 'undefined' && value !== '')
                  ),
              }}
            />
            <Input
              name="address.postCode"
              label="Postcode"
              disabled={formDisabled}
              InputLabelProps={{
                shrink:
                  formDisabled ||
                  !(
                    // @ts-ignore
                    (typeof value !== 'undefined' && value !== '')
                  ),
              }}
            />
          </Box>
          <Box sx={{ display: 'flex', width: '50%' }}>
            <Input
              name="address.country"
              label="Country"
              disabled={formDisabled}
              InputLabelProps={{
                shrink:
                  formDisabled ||
                  !(
                    // @ts-ignore
                    (typeof value !== 'undefined' && value !== '')
                  ),
              }}
            />
          </Box>
        </Box>

        <FormLabel>Transport Type</FormLabel>
        <Box
          component={'div'}
          sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}
        >
          <Checkbox
            name="services.Taxi"
            label={'Taxi'}
            disabled={formDisabled}
          />

          <Checkbox
            name="services.Coach"
            label={'Coach'}
            disabled={formDisabled}
          />
          <Checkbox
            name="services.CarRental"
            label={'Car rental'}
            disabled={formDisabled}
          />
          <Checkbox
            name="services.MicroMobility"
            label={'Micro Mobility'}
            disabled={formDisabled}
          />
        </Box>
        <FormLabel>Terms & Conditions</FormLabel>

        <Input
          name="termsAndConditions"
          label={`URL`}
          disabled={formDisabled}
          sx={{ width: '50%' }}
        />

        <Box
          component="div"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'flex-start',
            gap: '10px',
          }}
        >
          {!formDisabled && (
            <Button color="error" onClick={() => setFormDisabled(true)}>
              Cancel
            </Button>
          )}
          {formDisabled && (
            <Button onClick={() => setFormDisabled(false)}>Edit</Button>
          )}
          {!formDisabled && (
            <Button type="submit" disabled={isLoading}>
              Save
            </Button>
          )}
        </Box>
      </Form>
      <Snackbar open={error} autoHideDuration={6000}>
        <Alert severity="error">Error updating supplier details.</Alert>
      </Snackbar>
    </Grid>
  )
}

export default Company
